export default "__VITE_ASSET__ca8303ca__"